<template>
    <div>
        <div class="toggle-profile-btn-icon btn-hover-gray" v-if="!candidateSummarySideMenuOpen && onlyIcon" @click="toggleProfile()">
            <i class="fa-solid fa-circle-user user-icon"></i>&nbsp;<i class="fa-solid fa-chevron-right"></i>
        </div>
        <button v-if="!candidateSummarySideMenuOpen && !onlyIcon" @click="toggleProfile()" class="btn btn-outline btn-lg toggle-profile-btn btn-hover-gray">
            <i class="fa-solid fa-circle-user"></i>&nbsp;Profile&nbsp;<i class="fa-solid fa-chevron-right"></i>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        onlyIcon: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            Accordion: {
                count: 0,
                active: null
            }
        };
    },
    methods: {
        toggleProfile() {
            this.$store.dispatch('candidateSummarySideMenuOpen', true);
        }
    },
    computed: {
        candidateSummarySideMenuOpen() {
            return this.$store.getters.candidateSummarySideMenuOpen;
        },
    },

};
</script>